<app-select-control
    (valueChange)="emit_valueChange($event)"
    [appearance]="input_appearance$$()"
    [control]="control$$()"
    [label]="label$$()"
    [list]="input_list$$()"
    [placeholder]="input_placeholder$$()"
    [readonly]="readonly$$()"
/>
